import * as store from "../state/store.js";
import { UNIT_CODE, type DxfUnit } from "../state/types.js";
import { rebuildGlbFromCurrent } from "./glb.js";

// Units and grid are editor-specific. Loading a DXF no longer inspects
// $INSUNITS or the drawing size — the coordinates in the file are always
// interpreted as whatever the editor is currently set to, and exports go out
// with the same $INSUNITS code. Users change these via the Units & Grid
// Settings modal.

export function codeFromUnit(unit: DxfUnit): number {
  for (const [k, v] of Object.entries(UNIT_CODE)) {
    if (v === unit) return Number.parseInt(k, 10);
  }
  return 1; // inches — the editor's default
}

export function applyUnitSettings(input: {
  dxfUnit: DxfUnit;
  viewerUnit: DxfUnit;
  gridUnit: DxfUnit;
  gridSpacing: number;
}): void {
  const prevDxfUnit = store.dxfUnit();
  store.batch(() => {
    store.write.dxfUnit(input.dxfUnit);
    store.write.dxfUnitCode(codeFromUnit(input.dxfUnit));
    store.write.viewerUnit(input.viewerUnit);
    store.write.gridUnit(input.gridUnit);
    store.write.gridSpacing(input.gridSpacing);
  });

  // Changing dxfUnit re-labels what "1 unit" means physically, so the GLB
  // baked at the old unit is now the wrong physical size (thickness slab
  // proportions, small-feature simplification thresholds, etc. all key off
  // the unit). Rebuild with the new unit code. `rebuildGlbFromCurrent`
  // no-ops on an empty model so we don't need to guard here.
  if (input.dxfUnit === prevDxfUnit) return;
  rebuildGlbFromCurrent();
}
